import {Alert, Box, Button, CircularProgress, Stack, styled} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import UploadIcon from "@mui/icons-material/Upload";
import React, {useRef, useState} from "react";
import axios from "axios";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export default function AITraining() {
    const [trainCompleted, setTrainCompleted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);

    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [prediction, setPrediction] = useState(null);

    const ref = useRef<HTMLInputElement | null>(null);

    const trainModel = async () => {
        setLoading(true)
        setTrainCompleted(false)
        setImagePreview(null);
        setPrediction(null)

        try {
            await axios.get('/train').then((response) => {
                if (response?.data?.status === "COMPLETED") {
                    setTrainCompleted(true)
                    window.flash("Training complete", 'info')
                }
            })
        } catch (error) {
            console.log(error)
            if (error && typeof error === 'object' && 'data' in error) {
                const errorMessage = (error as any).data?.message || 'An unknown error occurred';
                window.flash(errorMessage, 'error');
            }
        }

        setLoading(false);
    }


    const handleFileChange = async () => {
        const selectedFile = ref.current?.files && ref.current?.files[0];
        if (!selectedFile) return

        if (selectedFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result;
                if (typeof result === 'string') {
                    setImagePreview(result);
                }
            };
            reader.readAsDataURL(selectedFile);
        }

        await handleUpload(selectedFile)
    };

    const handleUpload = async (selectedFile: File) => {
        setLoadingUpload(true)
        setTrainCompleted(false)

        const formData = new FormData();
        formData.append('image', selectedFile);

        try {
            await axios.post('/train-testing', formData).then((response) => {
                if (response?.data?.prediction !== null && response?.data?.prediction !== undefined) {
                    setPrediction(response?.data?.prediction)
                }
            })
        } catch (error) {
            console.error(error);
            if (error && typeof error === 'object' && 'data' in error) {
                const errorMessage = (error as any).data?.message || 'An unknown error occurred';
                window.flash(errorMessage, 'error');
            }
        }
        setLoadingUpload(false)
    };

    return (
        <Box maxWidth={420} sx={{m: "auto", mt: 14}} pt={0} pl={2} pr={2}>
            {process.env.NODE_ENV === 'production' && (
                <Alert sx={{mb: 2}} severity="warning">Functions are disabled on production</Alert>
            )}

            <Alert severity="info">Snapshots are added to the server to train the AI</Alert>

            {trainCompleted && <Alert severity="success">Training completed</Alert>}
            {loading && <Alert severity="info">Training please wait</Alert>}

            <Stack direction="row" justifyContent="space-between" maxWidth={250} m="auto" mb={2} mt={2}>
                <LoadingButton disabled={process.env.NODE_ENV === 'production'} loading={loading} variant="outlined"
                               onClick={trainModel}>Train
                    AI</LoadingButton>

                <Button
                    disabled={process.env.NODE_ENV === 'production'}
                    component="label"
                    role={undefined}
                    onChange={handleFileChange}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<UploadIcon/>}
                >
                    Test image
                    <VisuallyHiddenInput ref={ref} type="file"/>
                </Button>
            </Stack>


            {loadingUpload ?
                <Stack direction="row" justifyContent="center" mt={20}>
                    <CircularProgress/>
                </Stack> : (
                    <>
                        {prediction === 0 && <Alert severity="info">Bowl is empty</Alert>}
                        {prediction === 1 && <Alert severity="info">Bowl is full</Alert>}
                    </>
                )}

            {!loadingUpload && imagePreview && (
                <Stack justifyContent="center" direction="row" mt={1}>
                    <img src={imagePreview} alt="Selected Preview" style={{maxWidth: '100%', height: '500px'}}/>
                </Stack>
            )}
        </Box>
    )
}
